import { createContext } from "react";

const SchematicContext = createContext();

export default SchematicContext;